import * as _ from 'lodash';
import { MultiInvoiceState} from "./state";
import { MultiInvoiceActions, MultiInvoiceAction} from './action';

const initialState = require('./initial-data.json') as MultiInvoiceState;
export function MultiInvoiceReducer(
    state: MultiInvoiceState = initialState, 
    action: MultiInvoiceAction
): MultiInvoiceState {
    switch (action.type)
    {
            case MultiInvoiceActions.LoadMultiInvoicePageAction:
                return {
                    ...state,
                    multiInvoice: action.payload
                };                        
            case MultiInvoiceActions.ChangeMultiInvoiceFilterExpressionAction:
                return {
                    ...state,
                    multiInvoice: null,
                    multiInvoiceTotalCount: 0,
                    multiInvoicePaging: { ...state.multiInvoicePaging, page: 1 },
                    multiInvoiceFilterExpression: action.payload
                };
            case MultiInvoiceActions.ChangeMultiInvoiceSortExpressionAction:
                return {
                    ...state,
                    multiInvoice: null,
                    multiInvoiceTotalCount: 0,
                    multiInvoicePaging: { ...state.multiInvoicePaging, page: 1 },
                    multiInvoiceSortExpression: action.payload
                };
            case MultiInvoiceActions.ChangeMultiInvoicePageAction:
                return {
                    ...state,
                    multiInvoice: null,
                    multiInvoiceTotalCount: 0,
                    multiInvoicePaging: { ...state.multiInvoicePaging, page: action.payload },
                };
            case MultiInvoiceActions.ChangeMultiInvoiceTotalCountAction:
                return {
                    ...state,
                    multiInvoiceTotalCount: action.payload.totalCount
                };            
            default:
                return state;
        }
    }
    